import { css } from '@emotion/react';

import { palette } from 'src/styles/constants';
import { getTheme } from 'src/utils/getTheme';

const { theme, isHosTheme } = getTheme();

export const styles = {
    loginDialogWrapper: css({
        display: 'flex',
        flexDirection: 'column',
        gap: '30px',
        alignSelf: 'stretch',
        [theme.breakpoints.up('lg')]: {
            width: '642px',
            padding: '60px 40px 40px 40px',
            gap: '30px',
        },
        ...(isHosTheme && {
            borderRadius: theme.custom.borderRadius[23],
            borderColor: theme.palette.secondary.dark,
            backgroundColor: theme.palette.common.white,
        }),
    }),
    loginFormWrapper: css({
        width: '100%',
        paddingTop: '10px',
    }),
    loginButton: css({
        marginTop: '30px',
        width: isHosTheme ? '185px' : '100%',
        borderRadius: '100px',
        padding: '16px',
    }),
    loginDialogCloseButton: css({
        position: 'absolute',
        top: '20px',
        right: '20px',
        [theme.breakpoints.up('lg')]: {
            top: '25px',
            right: '25px',
        },
    }),
    linkWrapper: css({
        alignItems: 'center',
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
    }),
    LoginInput: css({
        '& .MuiOutlinedInput-root': {
            borderRadius: '10px',

            '& fieldset': {
                borderColor: palette.common.black,
            },

            '&.Mui-focused fieldset': {
                borderColor: palette.common.black,
            },
        },
    }),
    forgottenPassword: css({
        padding: 0,
        marginTop: '20px',
        ...(isHosTheme && {
            '&:hover': {
                background: 'transparent',
            },
        }),
    }),
    forgottenPasswordText: css({
        color: theme.palette.text.secondary,
        textTransform: 'none',
        textDecoration: 'underline',
        ...(isHosTheme && {
            letterSpacing: '0.24px',
            color: theme.palette.text.primary,
            '&:hover': {
                color: theme.palette.primary.light,
            },
        }),
    }),
    loginDialogInput: css({
        '.MuiInput-input': {
            paddingTop: '10px',
            paddingBottom: '10px',
            fontSize: '16px',
        },
    }),
    loginDialogErrorBox: css({
        display: 'flex',
        padding: isHosTheme ? '16px' : '20px',
        alignItems: 'center',
        gap: isHosTheme ? '20px' : '10px',
        alignSelf: 'stretch',
        background: theme.palette.error.light,
        color: theme.palette.primary.main,
        marginBottom: '20px',

        ...(isHosTheme && {
            borderRadius: theme.custom.borderRadius[23],
            border: `1px solid ${theme.palette.error.main}`,
        }),
    }),
    otpInput: css({
        flex: 1,
        minWidth: '45px',
        height: '72px',
        borderRadius: '10px',
        border: `1px solid ${palette.common.black}`,
        backgroundColor: theme.palette.common.white,

        textAlign: 'center',
        fontSize: '2rem',
        fontFamily: 'inherit',

        outline: 'none',
        boxSizing: 'border-box',

        '&:focus, &:focus-visible': {
            border: `2px solid ${palette.common.black}`,
            boxShadow: 'none',
            outline: 'none',
        },

        '&:disabled': {
            backgroundColor: theme.palette.action.disabledBackground,
            color: theme.palette.text.disabled,
        },
    }),
    otpInputError: css({
        borderColor: theme.palette.error.main,
        boxShadow: `0 0 0 1px ${theme.palette.error.light}`,
        outline: 'none',
    }),
    tokenError: css({
        color: theme.palette.error.main,
    }),
    link: css({
        cursor: 'pointer',
        fontWeight: 600,
        textTransform: 'uppercase',
        '&:hover': {
            textDecoration: 'underline',
            color: theme.palette.primary.main,
        },
    }),
    resendLinkDisabled: css({
        cursor: 'default',
        opacity: 0.5,
        pointerEvents: 'none',
    }),
    separationLine: css({
        width: '100%',
        border: 'none',
        borderTop: `1px solid ${theme.palette.grey[300]}`,
        margin: '16px 0',
    }),
};
